import { sbaAxios } from "../utils/sbaAxios";
import { getActivities, getcategory, getactivityType, getActivityentityType, getActivityEntity, getActivityDetails,getAccountorContact } from "../../config/apiConfig";
import {
  FETCH_ACTIVITIES_BEGIN,
  FETCH_ACTIVITIES_SUCCESS,
  FETCH_ACTIVITIES_FAILURE,
  FETCH_CATEGORY_BEGIN,
  FETCH_CATEGORY_SUCCESS,
  FETCH_CATEGORY_FAILURE,
  FETCH_ACTIVITYTYPE_BEGIN,
  FETCH_ACTIVITYTYPE_SUCCESS,
  FETCH_ACTIVITYTYPE_FAILURE,
  FETCH_ACTIVITYENTITYTYPE_BEGIN,
  FETCH_ACTIVITYENTITYTYPE_SUCCESS,
  FETCH_ACTIVITYENTITYTYPE_FAILURE,
  FETCH_ACTIVITYENTITY_BEGIN,
  FETCH_ACTIVITYENTITY_FAILURE,
  FETCH_ACTIVITYENTITY_SUCCESS,
  FETCH_ACTIVITYDETAILS_BEGIN,
  FETCH_ACTIVITYDETAILS_FAILURE,
  FETCH_ACTIVITYDETAILS_SUCCESS,
  FETCH_ACCOUNTORCONTACT_BEGIN,
  FETCH_ACCOUNTORCONTACT_FAILURE,
  FETCH_ACCOUNTORCONTACT_SUCCESS
} from "../constants/investment";

// activities Grid
export const getActivitiesDetails=  (SourceId,EntityTypeIds,EntityId,ActiviyTypeIds,StartDate,EndDate,ActivitySubTypeIds,Subject,UserId)=> {
   return  (dispatch) => {
       dispatch(fetchActivitiesBegin());
       sbaAxios({
           url: `${getActivities}activitySourceId=${SourceId}&EntityTypeIds=${EntityTypeIds}&EntityId=${EntityId}&ActiviyTypeIds=${ActiviyTypeIds}&StartDate=${StartDate}&EndDate=${EndDate}&ActivitySubTypeIds=${ActivitySubTypeIds}&Subject=${Subject}&UserId=${UserId}`,
           method: 'get',
       })
      .then((repos) => {
        const Asset = repos;
        dispatch(fetchActivitiesSuccess(Asset));
        return Asset;
      })
      .catch((error) =>{ return dispatch(fetchActivitiesFailure(error))});
  };
}



export const fetchActivitiesBegin = () => ({
  type: FETCH_ACTIVITIES_BEGIN,
});

export const fetchActivitiesSuccess = (activitityDetails) => ({
  type: FETCH_ACTIVITIES_SUCCESS,
  payload: {activitityDetails},
});


export const fetchActivitiesFailure = (errorMessage) => ({
  type: FETCH_ACTIVITIES_FAILURE,
  payload: {errorMessage}
});



// activity  category
export const getCategory = (sourceId) => {
    return (dispatch) => {
        dispatch(fetchCategoryBegin());
        sbaAxios({
            url: `${getcategory}${sourceId}`,
            method: 'get',
        })
            .then((repos) => {
                const Category = repos;
                dispatch(fetchCategorySuccess(Category));
                return Category;
            })
            .catch((error) => { return dispatch(fetchCategoryFailure(error)) });
    };
}

export const fetchCategoryBegin = () => ({
    type: FETCH_CATEGORY_BEGIN,
});

export const fetchCategorySuccess = (Category) => ({
    type: FETCH_CATEGORY_SUCCESS,
    payload: { Category },
});

export const fetchCategoryFailure = (errorMessage) => ({
    type: FETCH_CATEGORY_FAILURE,
    payload: { errorMessage }
});

//activity type

export const getActivityType = () => {
    return (dispatch) => {
        dispatch(fetchActivityTypeBegin());
        sbaAxios({
            url: `${getactivityType}`,
            method: 'get',
        })
            .then((repos) => {
                const ActivityType = repos;
                dispatch(fetchActivityTypeSuccess(ActivityType));
                return ActivityType;
            })
            .catch((error) => { return dispatch(fetchActivityTypeFailure(error)) });
    };
}

export const fetchActivityTypeBegin = () => ({
    type: FETCH_ACTIVITYTYPE_BEGIN,
});

export const fetchActivityTypeSuccess = (ActivityType) => ({
    type: FETCH_ACTIVITYTYPE_SUCCESS,
    payload: { ActivityType },
});


export const fetchActivityTypeFailure = (errorMessage) => ({
    type: FETCH_ACTIVITYTYPE_FAILURE,
    payload: { errorMessage }
});



export const getActivityEntityType = (sourceId) => {
    return (dispatch) => {
        dispatch(fetchActivityentityTypeBegin());
        sbaAxios({
            url: `${getActivityentityType}${sourceId}`,
            method: 'get',
        })
            .then((repos) => {
                const ActivityentityType = repos;
                dispatch(fetchActivityentityTypeSuccess(ActivityentityType));
                return ActivityentityType;
            })
            .catch((error) => { return dispatch(fetchActivityentityTypeFailure(error)) });
    };
}

export const fetchActivityentityTypeBegin = () => ({
    type: FETCH_ACTIVITYENTITYTYPE_BEGIN,
});

export const fetchActivityentityTypeSuccess = (ActivityentityType) => ({
    type: FETCH_ACTIVITYENTITYTYPE_SUCCESS,
    payload: { ActivityentityType },
});


export const fetchActivityentityTypeFailure = (errorMessage) => ({
    type: FETCH_ACTIVITYENTITYTYPE_FAILURE,
    payload: { errorMessage }
});




export const getActivityEntities = (entityType, searchTerms, sourceid) => {
   
    return (dispatch) => {
        dispatch(fetchActivityentityBegin());
        sbaAxios({
            url: `${getActivityEntity}ActivityEntityTypeIds=${entityType}&SearchString=${searchTerms}&activitySourceId=${sourceid}`,
            method: 'get',
        })
            .then((repos) => {
                const Activityentity = [{
                    "ActivityEntityType": "",
                    "ActivityEntityTypeId": 0,
                    "EntityId": -1,
                    "EntityName": "--Please Select--"
                }, ...repos.sort((a, b) =>
                    a.EntityName.localeCompare(b.EntityName))];
                dispatch(fetchActivityentitySuccess(Activityentity));
                return Activityentity;
            })
            .catch((error) => { return dispatch(fetchActivityentityFailure(error)) });
    };
}

export const fetchActivityentityBegin = () => ({
    type: FETCH_ACTIVITYENTITY_BEGIN,
});

export const fetchActivityentitySuccess = (Activityentity) => ({
    type: FETCH_ACTIVITYENTITY_SUCCESS,
    payload: { Activityentity },
});


export const fetchActivityentityFailure = (errorMessage) => ({
    type: FETCH_ACTIVITYENTITY_FAILURE,
    payload: { errorMessage }
});

export const getActivityDetail = (ActiviyId,sourceId) => {
    return (dispatch) => {
        dispatch(fetcActivitydetailsBegin());
        sbaAxios({
            url: `${getActivityDetails}${ActiviyId},${sourceId}`,
            method: 'get',
        })
            .then((repos) => {
                const Activity = repos;
                dispatch(fetchActivitydetailsSuccess(Activity));
                return Activity;
                console.log(Activity);
            })
            .catch((error) => { return dispatch(fetchActivitydetailsFailure(error)) });
    };
}

export const fetcActivitydetailsBegin = () => ({
    type: FETCH_ACTIVITYDETAILS_BEGIN,
});

export const fetchActivitydetailsSuccess = (activityDetail) => ({
    type: FETCH_ACTIVITYDETAILS_SUCCESS,
    payload: { activityDetail },
});


export const fetchActivitydetailsFailure = (errorMessage) => ({
    type: FETCH_ACTIVITYDETAILS_FAILURE,
    payload: { errorMessage }
});
// Get Account or Contact.....
export const getAccountorContactAction = (sourceId) => {
    return (dispatch) => {
        dispatch(fetchAccountorContactBegin());
        sbaAxios({
            url: `${getAccountorContact}?activitySourceId=${sourceId}`,
            method: 'get',
        })
            .then((repos) => {
                const entities = repos;
                dispatch(fetchAccountorContactSuccess(entities));
                return entities;
               
            })
            .catch((error) => { return dispatch(fetchAccountorContactFailure(error)) });
    };
}

export const fetchAccountorContactBegin = () => ({
    type: FETCH_ACCOUNTORCONTACT_BEGIN,
});

export const fetchAccountorContactSuccess = (activityEntities) => ({
    type: FETCH_ACCOUNTORCONTACT_SUCCESS,
    payload: { activityEntities },
});


export const fetchAccountorContactFailure = (errorMessage) => ({
    type:FETCH_ACCOUNTORCONTACT_FAILURE,
    payload: { errorMessage }
});
